/**
 * Sentinel code used in VolunteerRole.eventTypeMapping meaning
 * "any track event" — an event whose club EventType category is
 * Track or Training. It is never a real event code (real codes are
 * < 100; program placeholders are >= 1000). Must match the API's
 * EventTypeConstants.TrackEventsMappingCode.
 */
export const TRACK_EVENTS_CODE = 900;

/**
 * Club EventType categories that count as "track events" for
 * volunteer role matching.
 */
export const TRACK_EVENT_CATEGORIES = ['Track', 'Training'];

/**
 * Recordable Event Type Codes
 *
 * This is the whitelist of event types that results can be recorded for:
 * the ones the event dialog offers for a new event. Most are recorded in the
 * timing and field apps. The three shuttle relays are typed on the website
 * only, from stopwatch times: a shuttle relay finishes on its own start line,
 * which the hub cannot time (docs/school-carnivals-step-3-relays.md, 1.6).
 *
 * Vortex is typed on the website only too: neither app can record it. It can
 * be added as an event, or a Javelin recorded in the Field Events app can be
 * changed to it (Doug, 2026-10-15; register R45).
 *
 * Display-only events (e.g., "Play Hurdles", "Floppy Jump") are NOT included
 * in this list and should only appear in meet programs.
 */
export const RECORDABLE_EVENT_CODES = [
  // Training Events
  1,  // Sprint Training
  2,  // Flying Start
  3,  // Shuttle Run
  4,  // Lap Training
  6,  // Agility Training

  // Track Events - Hurdles
  15, // 300m Hurdles
  16, // 60m Hurdles
  17, // 80m Hurdles
  18, // 90m Hurdles
  19, // 200m Hurdles
  23, // 110m Hurdles
  26, // 400m Hurdles
  29, // 100m Hurdles

  // Track Events - Multi-Lane Sprints
  20, // 60m
  21, // 70m
  22, // 100m
  24, // 200m
  25, // 400m
  37, // 300m

  // Track Events - Relays
  70, // 4x60m
  27, // 4x70m
  28, // 4x100m
  34, // 4x200m
  35, // 4x400m
  71, // 4x50m Shuttle (website only)
  72, // 4x70m Shuttle (website only)
  73, // 4x100m Shuttle (website only)

  // Track Events - Distance
  31, // 800m
  32, // 1500m
  33, // 3000m
  36, // 5000m
  38, // 500m
  39, // 700m

  // Track Events - Walk
  41, // 300m Walk
  42, // 700m Walk
  43, // 1100m Walk
  44, // 1500m Walk
  45, // 500m Walk

  // Field Events
  61, // High Jump
  62, // Long Jump
  63, // Triple Jump
  64, // Discus
  65, // Javelin
  66, // Shot Put
  68, // Vortex (website only: neither app can record it)
];
